import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/not-found.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/menu/AdComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/menu/EditMenuButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/menu/Item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/menu/LanguageFlag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/menu/MenuPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/menu/NavigationMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/menu/ordering/DeliveryNotAvailable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/menu/ordering/OrderingCart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/vercel/path0/src/contexts/CartContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/sass/menu/Footer.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/sass/menu/Header.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/sass/menu/Section.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/sass/menu/Page.scss");
